import fileDownload from 'js-file-download';
import { useMutation } from 'react-query';
import { API } from 'api';
import { blobToString, downloadFileByBase64Str, isBase64 } from 'common';

export interface IDownloadAttendanceUploadFile {
  payload: {
    eid?: string;
    fileId: string;
    fileName: string;
    type: string;
    format?: string;
  };
}

const downloadAttendanceUploadFile = (payload: IDownloadAttendanceUploadFile['payload']) => {
  return API.newGetBlob('/api/admin/files/retrieve', payload);
};

export const useDownloadAttendanceUploadFile = () => {
  return useMutation(downloadAttendanceUploadFile, {
    onSuccess: async (data, payload: IDownloadAttendanceUploadFile['payload']) => {
      const result = await blobToString(data.data);
      if (isBase64(result) || result.includes('https://')) {
        return downloadFileByBase64Str(result, payload.fileName);
      }
      return fileDownload(data.data, payload.fileName);
    },
  });
};
